__turbopack_context__.v({
  "about": "IyJBBa_about",
  "acceligent": "IyJBBa_acceligent",
  "audubon": "IyJBBa_audubon",
  "blog": "IyJBBa_blog",
  "buttons": "IyJBBa_buttons",
  "careers": "IyJBBa_careers",
  "contact": "IyJBBa_contact",
  "cookie": "IyJBBa_cookie",
  "cookie-policy": "IyJBBa_cookie-policy",
  "eu-project": "IyJBBa_eu-project",
  "header": "IyJBBa_header",
  "icon": "IyJBBa_icon",
  "learn-rag": "IyJBBa_learn-rag",
  "lumin": "IyJBBa_lumin",
  "notepad": "IyJBBa_notepad",
  "pista": "IyJBBa_pista",
  "q-ant": "IyJBBa_q-ant",
  "squadlocker": "IyJBBa_squadlocker",
  "window": "IyJBBa_window",
  "work": "IyJBBa_work",
});
